import React from 'react';
import { IonItem, IonIcon, IonButton } from '@ionic/react';
import { moon, sunny } from 'ionicons/icons';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme } from '../redux/actions/themeActions';
import { ThemeType } from '../models/ThemeType';

const ThemeToggle: React.FC = () => {
  const dispatch = useDispatch();
  const { currentTheme } = useSelector((state: any) => state.theme);

  const handleToggleChange = () => {
    dispatch(toggleTheme());
  };

  return (
    <IonItem lines="full">
      <IonButton
        onClick={handleToggleChange}
        color={"primary"}
      >
      {currentTheme === ThemeType.DARK ?<IonIcon icon={sunny} slot="icon-only" />
      :
      <IonIcon icon={moon} slot="icon-only" />
      }</IonButton>
    </IonItem>
  );
};

export default ThemeToggle; 